import { ActionTree } from "vuex";
import { IOtherAppointment, IOtherAppointmentSlot } from "@/models";
import { AxiosResponse } from "axios";
import { apiClient } from "@/services";
import { IOtherAppointmentState } from "./state";
import { ADD_OTHER_APPOINTMENTS } from "./mutations-types";

export const actions: ActionTree<IOtherAppointmentState, number> = {
    async addOtherAppoitnment(context, data: IOtherAppointment): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/otherAppointments`, data);
        return response;
    },

    async editOtherAppointment(context, data: IOtherAppointment): Promise<AxiosResponse<void>> {
        const response = await apiClient.put<void>(`/otherAppointments/${data.otherAppointmentId}`, data);
        return response;
    },

    async deleteOtherAppointment(context, data: IOtherAppointment): Promise<AxiosResponse<void>> {
        const response = await apiClient.delete(`/otherAppointments/${data.otherAppointmentId}`);

        return response;
    },

    async fetchOtherAppointmentsByDay(context, data: any): Promise<AxiosResponse<IOtherAppointmentSlot[]>> {
        const response = await apiClient.get<IOtherAppointmentSlot[]>(`/otherAppointments?day=${data}`);
        context.commit(ADD_OTHER_APPOINTMENTS, response.data);

        return response;
    },
};
